import { useContext } from 'react';
import { ResponsiveContext } from 'grommet';

function useMobile() {
  const size = useContext(ResponsiveContext);
  return size === 'small';
}

export default useMobile;
